import { render, staticRenderFns } from "./QandA.vue?vue&type=template&id=ef9650aa&scoped=true&"
import script from "./QandA.vue?vue&type=script&lang=js&"
export * from "./QandA.vue?vue&type=script&lang=js&"
import style0 from "./QandA.vue?vue&type=style&index=0&id=ef9650aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9650aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef9650aa')) {
      api.createRecord('ef9650aa', component.options)
    } else {
      api.reload('ef9650aa', component.options)
    }
    module.hot.accept("./QandA.vue?vue&type=template&id=ef9650aa&scoped=true&", function () {
      api.rerender('ef9650aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hhemp/aicsp/modules/QandA.vue"
export default component.exports